import React from 'react';

const Index: React.FC = () => (
  <div style={{ padding: '1rem' }}>Home em construção</div>
);

export default Index;
